function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M78.4366 0H101.304C112.163 0 118 5.57744 118 14.6015C118 31.4382 99.4004 44.3476 76.3025 48.1494L66.6784 78H48.0578L58.7071 48.6926H51.3216L21.8426 78H0L78.4366 0ZM68.122 34.3209C83.6043 34.3209 99.2749 27.8661 99.2749 18.278C99.2749 16.1473 98.0405 15.0402 95.4671 15.0402H85.1526L65.7578 34.3209H68.1011H68.122Z",
  fill: "#FF4D1C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.442 39H133.7C148.828 39 155 44.6818 155 53.0375C155 65.9679 139.768 77.3316 120.372 81.4467C121.481 83.3476 122.15 85.5618 122.15 88.5908C122.15 101.73 101.875 117 74.0887 117H39L117.442 39ZM80.7006 102.399C95.0332 102.399 106.813 93.9384 106.813 87.5881C106.813 84.8099 105.035 83.0343 100.745 83.0343H93.5686L74.0678 102.419H80.7006V102.399ZM111.73 69.6235C122.82 69.6235 135.478 64.0461 135.478 58.1345C135.478 55.9202 133.909 54.6878 131.105 54.6878H122.025L107.001 69.6235H111.73Z",
  fill: "#FF4D1C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M208.856 39H231.978L197.17 91.0348L263.755 39H293L215.186 117H196.07L244.763 68.1821L181.935 117H165.019L198.374 68.6417L150.116 117H131L208.814 39H208.856Z",
  fill: "#FF4D1C"
});

function SvgLogoOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 117,
    viewBox: "0 0 293 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrange);
export default __webpack_public_path__ + "static/media/logo-orange.e7d17db72a470bb21717fe301ee28290.svg";
export { ForwardRef as ReactComponent };